import { useEffect, useState } from 'react';
import { useWindowWidth } from '@react-hook/window-size';

export const useMaxElementsHeight = (className: string) => {
  const width = useWindowWidth();

  const [maxHeight, setMaxHeight] = useState(0);

  useEffect(() => {
    setTimeout(() => { 
      const elementsArray = document.getElementsByClassName(className);
      let aux = 0;

      if (elementsArray.length > 0) {
      
        for (let element of elementsArray) {
          if (aux <= element.clientHeight) {
            aux = element.clientHeight;
          }
        }
        setMaxHeight(aux);
    
      }}, 10);
  }, [width]);

  return { maxHeight };
};

export const updateMinHeight = (maxHeight: number, className: string) => {
  if (maxHeight !== 0) {
    const elementsArray = document.getElementsByClassName(className);
    if (elementsArray.length > 0) {
      for (let element of elementsArray) {
        element.style.minHeight = `${maxHeight}px`;
      }
    }
  }
};
